module.exports = __webpack_public_path__ + "static/media/Riviera_Level_17.90ef7954.jpg";